function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "regenerator-runtime/runtime.js";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var LSUtils = {
  initialize: function initialize() {
    Object.resolve = function (path, obj) {
      return path.split('.').reduce(function (prev, curr) {
        return prev ? prev[curr] : undefined;
      }, obj || self);
    };
    Object.set = function (path, obj, value) {
      var schema = obj; // a moving reference to internal objects within obj

      var pList = path.split('.');
      var len = pList.length;
      for (var i = 0; i < len - 1; i++) {
        var elem = pList[i];
        if (!schema[elem]) schema[elem] = {};
        schema = schema[elem];
      }
      schema[pList[len - 1]] = value;
      return obj;
    };
    Object.byString = function (o, s) {
      s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
      s = s.replace(/^\./, ''); // strip a leading dot
      var a = s.split('.');
      for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
          o = o[k];
        } else {
          return;
        }
      }
      return o;
    };
    Array.prototype.last = function () {
      if (this.length == 0) return null;
      return this[this.length - 1];
    };
    Array.prototype.rlookup = function (key, value) {
      for (var i = this.length - 1; i >= 0; i--) {
        if (this[i][key] == value) {
          return this[i];
        }
      }
    };
    String.prototype.capitalizeFirstLetter = function () {
      return this.trim().toLowerCase().charAt(0).toUpperCase() + this.trim().slice(1).toLowerCase();
    };
    String.prototype.titleCase = function () {
      var splitStr = this.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      } // Directly return the joined string

      return splitStr.join(' ');
    };
    Number.prototype.formatMoney = function (c, d, t) {
      var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + '€';
    };
    Number.prototype.formatMoneyNoCurrency = function (c, d, t) {
      var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };
  },
  localStorage: {
    setItem: function setItem(key, item) {
      try {
        window.localStorage.setItem(key, JSON.stringify(item));
      } catch (ex) {
        console.log('localstorage unavailable');
        if (!window.fakeStorage) window.fakeStorage = {};
        window.fakeStorage[key] = item;
      }
    },
    getItem: function getItem(key) {
      try {
        var res = window.localStorage.getItem(key);
        if (res) return JSON.parse(res);else null;
      } catch (ex) {
        console.log('localstorage unavailable');
        if (!window.fakeStorage) window.fakeStorage = {};
        return window.fakeStorage[key];
      }
    },
    removeItem: function removeItem(key) {
      try {
        if (LSUtils.localStorage.getItem(key)) window.localStorage.removeItem(key);
      } catch (ex) {
        console.log('localstorage unavailable');
        if (window.fakeStorage[key]) delete window.fakeStorage[key];
      }
    }
  },
  saveEvent: function () {
    var _saveEvent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(eventType) {
      var data,
        event,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            data = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            //Build event object
            event = {
              timestamp: LSUtils.getUnixTime(),
              type: eventType,
              data: data
            }; //Post event to LSEventService.php
            _context.prev = 2;
            return _context.abrupt("return", fetch(LSUtils.url() + '/app/services/events', {
              method: 'POST',
              body: JSON.stringify(event),
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function (res) {
              return res.json();
            }));
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](2);
            console.log('Could not post event');
            console.log(_context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 6]]);
    }));
    function saveEvent(_x) {
      return _saveEvent.apply(this, arguments);
    }
    return saveEvent;
  }(),
  checkElement: function () {
    var _checkElement = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(selector) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(document.querySelector(selector) === null)) {
              _context2.next = 5;
              break;
            }
            _context2.next = 3;
            return new Promise(function (resolve) {
              return requestAnimationFrame(resolve);
            });
          case 3:
            _context2.next = 0;
            break;
          case 5:
            return _context2.abrupt("return", document.querySelector(selector));
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function checkElement(_x2) {
      return _checkElement.apply(this, arguments);
    }
    return checkElement;
  }(),
  twilio: {
    genNumbers: function genNumbers(regionCode) {
      var dfd = $.Deferred();
      $.ajax({
        url: LSUtils.url() + '/app/services/lstwilio',
        data: {
          cmd: 'newPhoneNumbers',
          regionCode: regionCode
        },
        success: function success(response) {
          response = JSON.parse(response);
          dfd.resolve(response);
        }
      });
      return dfd.promise();
    },
    buyNumber: function buyNumber(number, clientId) {
      var dfd = $.Deferred();
      $.ajax({
        url: LSUtils.url() + '/app/services/lstwilio',
        data: {
          cmd: 'buyPhoneNumber',
          phoneNumber: number,
          clientId: clientId
        },
        success: function success(response) {
          response = JSON.parse(response);
          dfd.resolve(response);
        }
      });
      return dfd.promise();
    },
    releaseNumber: function releaseNumber(clientId) {
      var dfd = $.Deferred();
      $.ajax({
        url: LSUtils.url() + '/app/services/lstwilio',
        data: {
          cmd: 'releaseNumber',
          clientId: clientId
        },
        success: function success(response) {
          response = JSON.parse(response);
          dfd.resolve(response);
        }
      });
      return dfd.promise();
    }
  },
  // do not encode if already encoded...
  betterEncodeURI: function betterEncodeURI(str) {
    var res = str;
    var decoded = decodeURIComponent(res);
    if (decoded === str) {
      // not encoded yet
      res = encodeURIComponent(res);
    }
    return res;
  },
  registerEventOnUserInteraction: function registerEventOnUserInteraction(callback) {
    $(window).bind('click', function () {
      callback();
    });
    $(window).bind('scroll', function () {
      callback();
    });
    $(window).bind('mousemove', function () {
      callback();
    });
    $(window).bind('touchstart', function () {
      callback();
    });
  },
  showToast: function showToast(options) {
    options.type = options.type ? options.type : 'success';
    options.isAutoClosable = options.isAutoClosable === false ? options.isAutoClosable : true;
    options.title = options.title ? options.title : 'Notifications';
    var $toast = $('<div class="toast shadow ' + ('toast-' + options.type) + '">' + '    <div class="toast-header">' + '      <i class="fa fa-info-circle"></i>&nbsp;&nbsp;' + '      <strong class="mr-auto">' + options.title + '</strong>' + '      <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' + '        <span aria-hidden="true">&times;</span>' + '      </button>' + '    </div>' + '    <div class="toast-body">' + options.message + '    </div>' + '  </div>');
    $('[data-dismiss="toast"]', $toast).bind('click', function () {
      $toast.fadeOut('fast');
    });
    $('#container-header .container').append($toast);
    if (options.isAutoClosable) setTimeout(function () {
      $toast.fadeOut('slow');
    }, 5000);
  },
  addNote: function addNote(clientId, content) {
    return $.ajax({
      url: LSUtils.url() + '/app/services/notes',
      type: 'PUT',
      data: JSON.stringify({
        timestamp: LSUtils.getUnixTime(),
        clientId: clientId,
        content: content,
        isEditable: false,
        authorId: 42
      })
    });
  },
  waitForUpdate: function waitForUpdate(condition, url) {
    var dfd = $.Deferred();
    var isResolved = false;
    var loop = setInterval(function () {
      $.ajax({
        url: url
      }).done(function (resp) {
        resp = JSON.parse(resp);
        var data = resp.data[0];
        try {
          if (!isResolved && eval('(data.' + condition + ')')) {
            isResolved = true;
            clearInterval(loop);
            dfd.resolve(data);
          }
        } catch (ex) {
          // just in case
        }
      });
    }, 1500);
    var to = setTimeout(function () {
      clearInterval(loop);
    }, 30 * 1000);
    return dfd.promise();
  },
  openFSIFModal: function openFSIFModal(url, title, isFullscreen, onIframeLoad, popUpHolder) {
    popUpHolder = popUpHolder ? popUpHolder : this;
    var self = this;
    var height = isFullscreen ? window.innerHeight - 55 : 400;
    debugger;
    var $iframe = $('<div class="fsismodal">' + '   <div id="iframe-loader" class="text-center" style="position: absolute; top: 50%; left: 50%; margin-top: -45px; margin-left: -100px;">' + '       <img ' + '           src="' + LSUtils.url() + '/common/assets/img/ajax-loader.gif" ' + '            alt="loading"/>' + '       <p style="margin-top: 15px;color: lightgrey">Loading Page, please wait...</p>' + '   </div>' + '   <iframe src="' + url + (url.indexOf('?') >= 0 ? '&' : '?') + 'header=no' + '"' + '        style="border: none;background-color: white; width: 100%;' + (height ? 'height:' + height + 'px;' : '') + 'margin-top: -50px;overflow:hidden;transition: 0.5s ease-in-out height;">' + '   </iframe>' + '</div>');
    $('iframe', $iframe).bind('load', function () {
      try {
        var _height = $('.step', $(this)[0].contentWindow.document).height();
        $('iframe', $iframe).height(_height);
      } catch (ex) {
        // just in case
      }
      $('#iframe-loader').fadeOut();
      var newIframeUrl = $(this)[0].contentWindow.location.href;
      if (newIframeUrl === 'about:blank') {
        $('#iframe-loader').show();
        setTimeout(function () {
          popUpHolder.popup.close();
        }, 100);
      }
      if (onIframeLoad) onIframeLoad(newIframeUrl, $(this)[0]);
    });
    $(window).bind('resize', function () {
      if (isFullscreen) $('iframe', $iframe).css('height', height + 'px');
    });
    if (typeof window.history.replaceState === 'function') {
      var path = url.replace(Utils.url(), '');
      window.history.pushState(null, null, '#modal-open' + path);
    }

    // BootstrapDialog.SIZE_NORMAL = 'size-normal';
    // BootstrapDialog.SIZE_SMALL = 'size-small';
    // BootstrapDialog.SIZE_WIDE = 'size-wide';    // size-wide is equal to modal-lg
    // BootstrapDialog.SIZE_LARGE = 'size-large';

    popUpHolder.popup = BootstrapDialog.show({
      size: isFullscreen ? BootstrapDialog.SIZE_LARGE : BootstrapDialog.SIZE_NORMAL,
      closable: true,
      title: title,
      fullscreen: isFullscreen ? isFullscreen : true,
      onhidden: function onhidden() {
        if (window.location.hash.includes('#modal-open')) window.history.replaceState(null, null, '#');
      },
      message: $iframe
    });
    return $iframe;
  },
  clone: function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  hideLoading: function hideLoading() {
    $('#loading').hide();
  },
  showLoading: function showLoading() {
    $('#loading').show();
  },
  arrayLast: function arrayLast(array) {
    if (array && array.length) return array[array.length - 1];
    return null;
  },
  renderPopupWithIframe: function renderPopupWithIframe(options) {
    //           {
    //             width: 900,
    //             height: 450,
    //             src: '',
    //             title: '',
    //             isFullscreen: false,
    //             showHeader: false,
    //             showLoader: false,
    //             buttons: null
    //           }
    options.height = options.height ? options.height : window.innerHeight - 40;
    var $iframe = $('<div>' + '   <img id="iframe-loader" src="' + LSUtils.url() + '/common/assets/img/ajax-loader.gif" style="position: absolute; top: 50%; left: 50%; margin-top: -16px; margin-left: -16px;"/>' + '   <iframe src="" style="border: none; width: 100%; height: ' + options.height + 'px;overflow-y:scroll;"></iframe>' + '</div>');
    if (options.showLoader === false) $('#iframe-loader', $iframe).hide();
    $('iframe', $iframe).bind('load', function () {
      try {
        if ($(this)[0].contentWindow.location.href.indexOf(window.location.host) >= 0) $('#iframe-loader').fadeOut();
      } catch (ex) {}
    });
    var popup = BootstrapDialog.show({
      closable: typeof options.closable !== 'undefined' ? options.closable : true,
      fullscreen: typeof options.isFullscreen !== 'undefined' ? options.isFullscreen : true,
      title: options.title ? options.title : '',
      message: $iframe,
      buttons: options.buttons ? options.buttons : null
    });
    if (options.width) popup.getModalDialog().css('width', options.width + 'px');
    $('iframe', $iframe)[0].src = options.src;
    if (options.showHeader === false) $('.modal-header', popup.getModalDialog()).hide();
    return popup;
  },
  renderJson: function (_renderJson) {
    function renderJson(_x3, _x4) {
      return _renderJson.apply(this, arguments);
    }
    renderJson.toString = function () {
      return _renderJson.toString();
    };
    return renderJson;
  }(function (json, excludes) {
    var self = this;
    var res = $('<ul style="padding-left: 25px;"></ul>');
    if (json) {
      if (json instanceof Array) {
        // array
        json.forEach(function (elt) {
          res.append(renderJson(elt));
        });
      } else if (json instanceof Object) {
        // object
        for (var prop in json) {
          if (json[prop] instanceof Array) {
            var list = '';
            json[prop].forEach(function (elt) {
              if (elt instanceof Object) list += self.renderJson(elt);else list += elt + ',';
            });
            res.append('<li><small><span style="color:gray;">' + prop + '</span>: ' + list + '</small></li>');
          } else if (json[prop] instanceof Object) {
            res.append($('<li><small><span style="color:gray;">' + prop + '</span>: ' + self.renderJson(json[prop]) + '</small></li>'));
          } else {
            if (['total', 'subTotal', 'tax', 'price'].indexOf(prop) >= 0) {
              res.append($('<li><small><span style="color:gray;">' + prop + '</span>: ' + json[prop] + '</small></li>'));
            } else if (prop == 'timestamp') {
              res.append($('<li><small><span style="color:gray;">date</span>: ' + App.utils.timeFormatter(json[prop]) + '</small></li>'));
            } else {
              if (json[prop] == '') json[prop] = 'n/a';
              var show = true;
              if (excludes) {
                excludes.forEach(function (e) {
                  if (typeof json[prop] === 'string' && json[prop].indexOf(e) >= 0) {
                    show = false;
                  }
                });
              }
              if (show) res.append($('<li><small><span style="color:gray;">' + prop + '</span>: ' + json[prop] + '</small></li>'));
            }
          }
        }
      }
    }
    return $('<div></div>').append(res).html();
  }),
  waitForPolyfill: function () {
    var _waitForPolyfill = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var dfd, loop;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dfd = $.Deferred();
            if (LSUtils.isDebug()) dfd.resolve();else {
              loop = setInterval(function () {
                if (typeof regeneratorRuntime != 'undefined') {
                  clearInterval(loop);
                  dfd.resolve();
                }
              }, 250);
            }
            return _context3.abrupt("return", dfd.promise());
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function waitForPolyfill() {
      return _waitForPolyfill.apply(this, arguments);
    }
    return waitForPolyfill;
  }(),
  waitForDomElementToAppear: function waitForDomElementToAppear(elSelector) {
    var dfd = $.Deferred();
    var loop = setInterval(function () {
      if ($(elSelector).length > 0) {
        clearInterval(loop);
        loop = null;
        dfd.resolve();
      }
    }, 250);
    setTimeout(function () {
      if (loop) clearInterval(loop);
    }, 5000);
    return dfd.promise();
  },
  sleep: function sleep(time) {
    return new Promise(function (r) {
      return setTimeout(r, time);
    });
  },
  sendEmail: function sendEmail(templateName, clientId, extraData) {
    var dfd = $.Deferred();
    $.ajax({
      url: App.utils.url() + '/app/services/email',
      data: {
        clientId: clientId,
        templateName: templateName,
        emailData: extraData
      },
      success: function success() {
        dfd.resolve();
      }
    });
    return dfd.promise();
  },
  refreshPageElement: function refreshPageElement(selector, pageUrl) {
    var dfd = $.Deferred();
    $('#loading').show();
    $.ajax({
      url: pageUrl,
      success: function success(html) {
        $('#loading').hide();
        if (Array.isArray(selector)) {
          selector.forEach(function (s) {
            $(s).replaceWith($(s, html).prop('outerHTML'));
          });
        } else {
          $(selector).replaceWith($(selector, html).prop('outerHTML'));
        }
        dfd.resolve();
      }
    });
    return dfd.promise();
  },
  isMobile: function isMobile() {
    return 'ontouchstart' in document.documentElement && window.innerWidth <= 1024 && !this.isWebView();
  },
  isWebView: function isWebView() {
    if (navigator.platform.substr(0, 2) === 'iP' && navigator.userAgent.toLowerCase().indexOf('crios') === -1) {
      //iOS (iPhone, iPod or iPad)
      var lte9 = /constructor/i.test(window.HTMLElement);
      var nav = window.navigator,
        ua = nav.userAgent,
        idb = !!window.indexedDB;
      if (ua.indexOf('Safari') !== -1 && ua.indexOf('Version') !== -1 && !nav.standalone) {
        //Safari (WKWebView/Nitro since 6+)
        return false;
      } else if (!idb && lte9 || !window.statusbar.visible) {
        //UIWebView
        return true;
      } else if (window.webkit && window.webkit.messageHandlers || !lte9 || idb) {
        //WKWebView
        return true;
      }
    }
    return false;
  },
  alert: function alert(msg, onOK) {
    var config = {
      closable: true,
      title: 'Alert',
      message: $('<p class="text-center">' + msg + '</p>')
    };
    var self = this;
    if (onOK) {
      config.buttons = [{
        label: 'OK',
        cssClass: 'btn-primary',
        action: function action($dialog) {
          self.popup[msg].close();
          onOK.apply(self);
        }
      }];
    }
    if (!self.popup) self.popup = [];
    self.popup[msg] = BootstrapDialog.show(config);
  },
  sendNotification: function sendNotification(content, icon, clientId) {
    var self = this;
    var dfd = $.Deferred();
    if (!ProcessRenderer.stepsArray || !ProcessRenderer.hasCustomNotifications() && (content !== self.notifGoToDocs || typeof processJson.documents != 'undefined')) {
      $.ajax({
        url: LSUtils.url() + '/app/services/lsnotifications',
        type: 'PUT',
        data: JSON.stringify({
          to: clientId,
          from: 'Admin',
          content: content,
          icon: icon
        }),
        success: function success(response) {
          response = JSON.parse(response);
          self.renderNotification(content, icon, response.data.$id);
        }
      });
    } else {
      dfd.resolve();
    }
    return dfd.promise();
  },
  renderNotification: function renderNotification(content, icon, id) {

    // throw 'renderNotification() not implemented...';
    // LSDashboard.notifCounter++;
    // $('.notification-counter').html(LSDashboard.notifCounter);
    // $('.notification-counter-2').html(LSDashboard.notifCounter);
    // $('.notification-counter').show();
    //
    // $('.notification-container').prepend([
    //     '<div data-notification-isRead="false" data-notification-id="' + id + '" class="panel panel-default panel-notification">',
    //     '<div class="panel-body" style="font-size: 12px; padding: 4px;">',
    //     '<div class="col-sm-1" style="text-align: center;font-size: 22px;">',
    //     '<i class="fa ' + icon + ' blue"></i>',
    //     '</div>',
    //     '<div class="col-sm-11" style="font-size: 12px; padding: 4px;">',
    //     content,
    //     '</div>',
    //     '</div>',
    //     '<div class="panel-footer">',
    //     '<small><i>' + (new Date()).toLocaleDateString() + ' ' + (new Date()).toLocaleTimeString() + '</i></small>',
    //     '</div>',
    //     '</div>'
    // ].join(''));
  },
  showPopup: function showPopup(title, templatePath, twigData) {
    var self = this;
    $.ajax({
      url: LSUtils.url() + '/app/services/cmsData',
      data: {
        path: templatePath,
        twigData: encodeURI(twigData)
      },
      success: function success(html) {
        self.popup = BootstrapDialog.show({
          title: title,
          closable: true,
          message: $(html)
        });
      }
    });
    return false;
  },
  saveEmail: function saveEmail(email) {
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + '/app/services/customer?clientId=' + clientId,
      type: 'POST',
      data: {
        'emails.contact': email,
        'emails.contactSavedOn': window.location.pathname
      },
      success: function success() {
        dfd.resolve();
      }
    });
    return dfd.promise();
  },
  validateEmail: function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  formatUKPhoneNumbers: function formatUKPhoneNumbers(phoneNumber) {
    return phoneNumber.replace('+', '').replace(/^44/, '').replace(/\s+/g, '').replace(/^0/, '').replace(/(.)(\d{4})(\d)/, '0$1$2 $3');
  },
  isDebug: function isDebug() {
    return window.location.href.includes('localhost') || window.location.href.includes('dev') || window.location.href.includes('test') || window.location.href.includes('192.168.1.') || window.location.href.includes('10.201.');
  },
  isQA: function isQA() {
    return window.location.href.includes('qa.');
  },
  isTouchDevice: function isTouchDevice() {
    return 'ontouchstart' in window;
  },
  isSamsung: function isSamsung() {
    return window.navigator.userAgent.indexOf('SAMSUNG') >= 0 || window.navigator.userAgent.indexOf('UCBrowser') >= 0;
  },
  isIOS: function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  isIE: function isIE() {
    return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident') > -1;
  },
  url: function url() {
    // if (window.location.href.includes('/lab/design/ls_wp_2/'))
    //     return 'http://localhost/legalstart/lab/design/ls_wp_2/';

    var urlArray = window.location.href.split('/');
    if (urlArray[2] === 'localhost') {
      return 'http://' + urlArray[2] + '/' + urlArray[3];
    } else if (urlArray[2].indexOf('192.168') >= 0 || urlArray[2].indexOf('10.112') >= 0) {
      return 'http://' + urlArray[2] + '/' + urlArray[3];
    } else {
      return 'https://' + urlArray[2];
    }
  },
  readCookie: function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  getUnixTime: function getUnixTime() {
    var now = new Date();
    return (now.getTime() / 1000).toFixed(0);
  },
  formatMoney: function formatMoney(amount) {
    if (typeof clientData.lang == 'undefined') clientData.lang = {
      type: 'en',
      form: {
        labels: {
          currency: '$'
        }
      }
    };
    if (clientData.lang.type === 'en') {
      return clientData.lang.form.labels.currency + parseFloat(amount.replace(',', '.')).toFixed(2);
    } else {
      return parseFloat(amount.replace(',', '.')).toFixed(2) + ' ' + clientData.lang.form.labels.currency;
    }
  },
  timeFormatter: function timeFormatter(UNIX_timestamp, dateOnly) {
    if (UNIX_timestamp == 0) {
      return '-';
    }
    var a = new Date(UNIX_timestamp * 1000);
    var year = a.getFullYear();
    var month = a.getMonth() + 1;
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    if (dateOnly === true) {
      return date + '/' + month + '/' + year;
    }
    if (dateOnly === 'mobile') {
      return date + '/' + month + '/' + year + '<span class="hidden-xs"> - ' + hour + ':' + min + '</span>';
    }
    hour = hour < 10 ? '0' + hour : hour;
    min = min < 10 ? '0' + min : min;
    return date + '/' + month + '/' + year + ' - ' + hour + ':' + min;
  },
  getQueryStringParameter: function getQueryStringParameter(name, url) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(typeof url != 'undefined' ? url : location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  },
  emailValidator: function emailValidator(email) {
    var RFCEmail = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    return email.match(RFCEmail);
  },
  entity: null,
  clientId: null,
  getMongoEntity: function getMongoEntity(clientId) {
    var dfd = $.Deferred();
    var self = this;
    if (!this.entity) {
      this.clientId = clientId;
      $.ajax({
        url: this.url() + '/app/services/customers',
        data: {
          clientId: this.clientId
        },
        success: function success(response) {
          self.entity = JSON.parse(response).data[0];
          dfd.resolve(self.entity);
        }
      });
    } else {
      dfd.resolve(self.entity);
    }
    return dfd.promise();
  },
  companyHouseData: null,
  getCompanyHouseData: function getCompanyHouseData(companyNumber) {
    var dfd = $.Deferred();
    var self = this;
    $.ajax({
      url: this.url() + '/app/services/companyHouseJSON?cmd=companyProfile&param=' + companyNumber,
      success: function success(response) {
        self.companyHouseData = JSON.parse(response).data;
        dfd.resolve(self.companyHouseData);
      }
    });
    return dfd.promise();
  },
  getCompanyNumberFromFiling: function getCompanyNumberFromFiling(clientData) {
    var _clientData$processDa, _clientData$authentic, _clientData$vatData, _clientData$companyVe;
    if ((_clientData$processDa = clientData.processData) !== null && _clientData$processDa !== void 0 && (_clientData$processDa = _clientData$processDa.companyHouse) !== null && _clientData$processDa !== void 0 && (_clientData$processDa = _clientData$processDa.status) !== null && _clientData$processDa !== void 0 && _clientData$processDa.CompanyNumber) return clientData.processData.companyHouse.status.CompanyNumber;
    if ((_clientData$authentic = clientData.authenticationData) !== null && _clientData$authentic !== void 0 && (_clientData$authentic = _clientData$authentic.code) !== null && _clientData$authentic !== void 0 && _clientData$authentic.companyNumber) return clientData.authenticationData.code.companyNumber;
    if ((_clientData$vatData = clientData.vatData) !== null && _clientData$vatData !== void 0 && (_clientData$vatData = _clientData$vatData.companyInformationVAT) !== null && _clientData$vatData !== void 0 && _clientData$vatData.fields_companyRegistrationNumberIncludingPrefix_) return clientData.vatData.companyInformationVAT.fields_companyRegistrationNumberIncludingPrefix_;
    if ((_clientData$companyVe = clientData.companyVerificationData) !== null && _clientData$companyVe !== void 0 && (_clientData$companyVe = _clientData$companyVe.companyVerification) !== null && _clientData$companyVe !== void 0 && _clientData$companyVe.companyNumber) return clientData.companyVerificationData.companyVerification.companyNumber;
    if (clientData.emails.companyNumber && clientData.formData.type.indexOf('/creation') == -1) return clientData.emails.companyNumber;
    return null;
  },
  setMongoEntity: function setMongoEntity(entity, clientId) {
    entity = JSON.stringify(entity);
    if (typeof clientId != 'undefined') this.clientId = clientId;
    this.entity = entity;
    if (entity) {
      return $.ajax({
        url: this.url() + '/app/services/customer?clientId=' + this.clientId,
        type: 'POST',
        data: entity
      });
    } else {
      return null;
    }
  },
  setFlag: function setFlag(clientId, flagId) {
    var self = this;
    this.getMongoEntity(clientId).done(function (entity) {
      var _entity$processData;
      if (typeof (entity === null || entity === void 0 || (_entity$processData = entity.processData) === null || _entity$processData === void 0 ? void 0 : _entity$processData.steps) !== "undefined") {
        entity.processData.steps[entity.processData.steps.length - 1].flags = [{
          id: flagId,
          timestamp: self.getUnixTime()
        }];
        self.setMongoEntity(entity);
      }
    });
  },
  // used in form company name
  removeDiacritics: function removeDiacritics(str) {
    var defaultDiacriticsRemovalMap = [{
      'base': 'A',
      'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
    }, {
      'base': 'AA',
      'letters': /[\uA732]/g
    }, {
      'base': 'AE',
      'letters': /[\u00C6\u01FC\u01E2]/g
    }, {
      'base': 'AO',
      'letters': /[\uA734]/g
    }, {
      'base': 'AU',
      'letters': /[\uA736]/g
    }, {
      'base': 'AV',
      'letters': /[\uA738\uA73A]/g
    }, {
      'base': 'AY',
      'letters': /[\uA73C]/g
    }, {
      'base': 'B',
      'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
    }, {
      'base': 'C',
      'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
    }, {
      'base': 'D',
      'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
    }, {
      'base': 'DZ',
      'letters': /[\u01F1\u01C4]/g
    }, {
      'base': 'Dz',
      'letters': /[\u01F2\u01C5]/g
    }, {
      'base': 'E',
      'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
    }, {
      'base': 'F',
      'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
    }, {
      'base': 'G',
      'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
    }, {
      'base': 'H',
      'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
    }, {
      'base': 'I',
      'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
    }, {
      'base': 'J',
      'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g
    }, {
      'base': 'K',
      'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
    }, {
      'base': 'L',
      'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
    }, {
      'base': 'LJ',
      'letters': /[\u01C7]/g
    }, {
      'base': 'Lj',
      'letters': /[\u01C8]/g
    }, {
      'base': 'M',
      'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
    }, {
      'base': 'N',
      'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
    }, {
      'base': 'NJ',
      'letters': /[\u01CA]/g
    }, {
      'base': 'Nj',
      'letters': /[\u01CB]/g
    }, {
      'base': 'O',
      'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
    }, {
      'base': 'OI',
      'letters': /[\u01A2]/g
    }, {
      'base': 'OO',
      'letters': /[\uA74E]/g
    }, {
      'base': 'OU',
      'letters': /[\u0222]/g
    }, {
      'base': 'P',
      'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
    }, {
      'base': 'Q',
      'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
    }, {
      'base': 'R',
      'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
    }, {
      'base': 'S',
      'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
    }, {
      'base': 'T',
      'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
    }, {
      'base': 'TZ',
      'letters': /[\uA728]/g
    }, {
      'base': 'U',
      'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
    }, {
      'base': 'V',
      'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
    }, {
      'base': 'VY',
      'letters': /[\uA760]/g
    }, {
      'base': 'W',
      'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
    }, {
      'base': 'X',
      'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
    }, {
      'base': 'Y',
      'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
    }, {
      'base': 'Z',
      'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
    }, {
      'base': 'a',
      'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
    }, {
      'base': 'aa',
      'letters': /[\uA733]/g
    }, {
      'base': 'ae',
      'letters': /[\u00E6\u01FD\u01E3]/g
    }, {
      'base': 'ao',
      'letters': /[\uA735]/g
    }, {
      'base': 'au',
      'letters': /[\uA737]/g
    }, {
      'base': 'av',
      'letters': /[\uA739\uA73B]/g
    }, {
      'base': 'ay',
      'letters': /[\uA73D]/g
    }, {
      'base': 'b',
      'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
    }, {
      'base': 'c',
      'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
    }, {
      'base': 'd',
      'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
    }, {
      'base': 'dz',
      'letters': /[\u01F3\u01C6]/g
    }, {
      'base': 'e',
      'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
    }, {
      'base': 'f',
      'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
    }, {
      'base': 'g',
      'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
    }, {
      'base': 'h',
      'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
    }, {
      'base': 'hv',
      'letters': /[\u0195]/g
    }, {
      'base': 'i',
      'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
    }, {
      'base': 'j',
      'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
    }, {
      'base': 'k',
      'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
    }, {
      'base': 'l',
      'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
    }, {
      'base': 'lj',
      'letters': /[\u01C9]/g
    }, {
      'base': 'm',
      'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
    }, {
      'base': 'n',
      'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
    }, {
      'base': 'nj',
      'letters': /[\u01CC]/g
    }, {
      'base': 'o',
      'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
    }, {
      'base': 'oi',
      'letters': /[\u01A3]/g
    }, {
      'base': 'ou',
      'letters': /[\u0223]/g
    }, {
      'base': 'oo',
      'letters': /[\uA74F]/g
    }, {
      'base': 'p',
      'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
    }, {
      'base': 'q',
      'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
    }, {
      'base': 'r',
      'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
    }, {
      'base': 's',
      'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
    }, {
      'base': 't',
      'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
    }, {
      'base': 'tz',
      'letters': /[\uA729]/g
    }, {
      'base': 'u',
      'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
    }, {
      'base': 'v',
      'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
    }, {
      'base': 'vy',
      'letters': /[\uA761]/g
    }, {
      'base': 'w',
      'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
    }, {
      'base': 'x',
      'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
    }, {
      'base': 'y',
      'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
    }, {
      'base': 'z',
      'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
    }];
    for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
      str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
    }
    return str;
  },
  customAjax: function customAjax(options) {
    var self = this;
    $.ajax(_objectSpread(_objectSpread({}, options), {}, {
      xhrFields: {
        withCredentials: true
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        if (jqXHR.status === 401) {
          self.refreshToken().then(function (status) {
            if (!status) {
              self.showAlert({
                title: 'Important Information',
                message: 'Please login using auth'
              });
              return false;
            }
            if (status) {
              $.ajax(_objectSpread(_objectSpread({}, options), {}, {
                xhrFields: {
                  withCredentials: true
                }
              }));
            }
          }).catch(function () {
            self.showAlert({
              title: 'Important Information',
              message: 'Please login using auth'
            });
            return false;
          });
        } else {
          var _jqXHR$responseJSON, _jqXHR$responseJSON2;
          self.showAlert({
            title: 'Important Information',
            message: !(jqXHR !== null && jqXHR !== void 0 && (_jqXHR$responseJSON = jqXHR.responseJSON) !== null && _jqXHR$responseJSON !== void 0 && (_jqXHR$responseJSON = _jqXHR$responseJSON.error) !== null && _jqXHR$responseJSON !== void 0 && _jqXHR$responseJSON.message) ? "Unknown error. Please try again." : jqXHR === null || jqXHR === void 0 || (_jqXHR$responseJSON2 = jqXHR.responseJSON) === null || _jqXHR$responseJSON2 === void 0 || (_jqXHR$responseJSON2 = _jqXHR$responseJSON2.error) === null || _jqXHR$responseJSON2 === void 0 ? void 0 : _jqXHR$responseJSON2.message
          });
        }
      }
    }));
  },
  refreshToken: function () {
    var _refreshToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", new Promise(function (resolve, reject) {
              $.ajax({
                url: "".concat(config.app.ngdAuth, "/refresh"),
                type: 'GET',
                xhrFields: {
                  withCredentials: true
                },
                success: function success(response) {
                  var _response$data;
                  if (!!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.granted) && response.data.granted.includes("refreshToken")) {
                    resolve(true);
                  }
                  resolve(false);
                },
                error: function error(_error) {
                  reject(_error);
                }
              });
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function refreshToken() {
      return _refreshToken.apply(this, arguments);
    }
    return refreshToken;
  }(),
  showAlert: function showAlert(options) {
    var _options$title = options.title,
      title = _options$title === void 0 ? 'Important Information' : _options$title,
      message = options.message,
      _options$className = options.className,
      className = _options$className === void 0 ? 'btn-primary' : _options$className;
    var self = this;
    if (!message) return;
    self.popup = BootstrapDialog.show({
      closable: true,
      title: title,
      message: "<div style=\"max-height: 400px;\"><p>".concat(message, "</p></div>"),
      buttons: [{
        label: lang.form.buttons.continue,
        cssClass: className,
        action: function action() {
          self.popup.close();
        }
      }]
    });
  }
};
$(function () {
  LSUtils.initialize();
});
export { LSUtils };